import React from 'react';
const TheadTableSolicitudLogs = () => {
  return (
    <thead className="bg-gray-800 text-white">
      <tr>
        <th className=" rounded-tl-lg px-4 py-3 text-left  text-sm">Fecha</th>
        <th className=" px-4 py-3 text-left  text-sm">Tipo</th>
        <th className=" px-4 py-3 text-left  text-sm">Detalles</th>
      </tr>
    </thead>
  );
};
export default TheadTableSolicitudLogs;
